// extracted by mini-css-extract-plugin
module.exports = {"containerForm":"login_containerForm__2scM4","row":"login_row__2CzdL","form":"login_form__2fAha","title":"login_title__rNGrS","reset":"login_reset__1QFWv"};